import { create } from 'zustand';
import { getTalents } from '@libs/api/talents';

type InitialState = {
  loading: boolean;
  initiated: boolean;
  data: TalentItem[];
  loadData: (options: { search?: string; location?: string; qualifications?: string[] }) => void;
};

export const useAssignStore = create<InitialState>()((set) => ({
  loading: false,
  initiated: false,
  data: [],
  loadData: async ({ search, qualifications, location }) => {
    set({ loading: true });
    try {
      const data = await getTalents({
        search,
        filters: {
          ...(location ? { locations: { key: 'locations', value: [location] } } : {}),
          ...(qualifications ? { qualifications: { key: 'qualifications', value: qualifications } } : {}),
          status: { key: 'status', value: ['Active'] },
        },
        page: 1,
        size: 20,
        orderBy: [{ field: 'lastName', sort: 'asc' }],
      });
      set({
        loading: false,
        data: data.items,
      });
    } finally {
      set({ loading: false, initiated: true });
    }
  },
}));

export type TalentItem = {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  qualifications: {
    id: string;
    abbreviation: string;
  }[];
  staffingType: 'Internal' | 'Agency' | 'DirectContractor';
};
